import React from 'react'
import { InformfixService, HomeService } from '../../services'
import { PageHeader } from 'antd'
import { inject, observer } from 'mobx-react'
// import { photos as photosItem } from '../../components/gallery/photos'

import 'react-fancybox/lib/fancybox.css'
import InformfixVew from '../../components/informfix/inform-view'

@inject('informStore')
@observer
class InformfixDetailPage extends React.Component {
  state = {
    initLoading: true,
    inform: {},
    homeDetail: {},
    informJobs: [],
    jobStatuses: [],
    photos: [
      {
        src: 'https://source.unsplash.com/Dm-qxdynoEc/800x799',
        width: 1,
        height: 1,
      },
    ],
  }

  componentDidMount() {
    const id = this.props.match.params.id
    this.getInform(id)
  }

  getInform = (id) => {
    // รูปภาพต่าง ๆ
    InformfixService.getGallery(id).then((rs) => {
      let photos = []
      if (rs) {
        this.setState({ photos: rs })
      }
    })

    // ข้อมูบใบแจ้งซ่อม
    InformfixService.view(id).then((res) => {
      const inform = res.data.data
      this.setState({
        inform: res.data['data'],
      })
      this.props.informStore.setItem(this.state.inform)
      // ข้อมูลบ้าน
      if (inform.home_id) {
        HomeService.view(inform.home_id).then((res) => {
          this.setState({
            visibleHomeDetail: true,
            homeDetail: res.data.data,
          })
          this.props.informStore.setHome(this.state.homeDetail)
        })
      }
    })

    // jobs
    InformfixService.getJobs(id).then((res) => {
      this.setState({
        informJobs: res.data.data,
      })
    })
  }

  render() {
    return (
      <React.Fragment>
        {this.state.inform ? (
          <PageHeader title="รายละเอียดใบแจ้งซ่อม">
            <InformfixVew
              item={this.state.inform}
              home={this.state.homeDetail}
              jobs={this.state.informJobs}
              photos={this.state.photos}
              jobStatuses={this.state.jobStatuses}
            />
          </PageHeader>
        ) : null}
      </React.Fragment>
    )
  }
}

export default InformfixDetailPage
